import { axios } from '..';

export type RequestTokenResponse = {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: 'Bearer';
  'not-before-policy': number;
  session_state: string;
  scope: string;
};

export const requestToken = (code: string, codeVerifier: string, redirectUri: string) => {
  return axios.post<RequestTokenResponse>('/token', { code, codeVerifier, redirectUri }).then(({ data }) => data);
};

export const requestTokenFromRefreshToken = (refreshToken: string) => {
  return axios.post<RequestTokenResponse>('/token/refresh', { refreshToken }).then(({ data }) => data);
};

export const logout = (refreshToken: string) => {
  return axios.post<RequestTokenResponse>('/token/logout', { refreshToken });
};
